import moment from 'moment';
import { ColaboradorPaqueteBitacora } from '../../../interfaces/Prestaciones.interface';

const Excel = require('exceljs');

const TIPO_LABEL: Record<string, string> = {
  ASIGNACION:   'Asignación',
  REASIGNACION: 'Reasignación',
  APROBACION:   'Aprobación',
  RECHAZO:      'Rechazo',
};

const parseFecha = (fecha: string | null | undefined): string => {
  if (!fecha) return '—';
  const num = Number(fecha);
  const m = !isNaN(num) && String(fecha).trim() !== '' ? moment(num) : moment(fecha);
  return m.format('DD/MM/YYYY HH:mm');
};

export const exportarHistorialColaboradorPaquete = (
  events: ColaboradorPaqueteBitacora[],
  nombreColaborador: string
) => {
  const workbook = new Excel.Workbook();
  const sheet = workbook.addWorksheet('Historial de Paquetes');

  const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '002060' } };
  const headerFont = { name: 'Arial', color: { argb: 'FFFFFF' }, bold: true, size: 11 };

  sheet.columns = [
    { header: 'FECHA SOLICITUD',   key: 'fechaSolicitud',   width: 22 },
    { header: 'TIPO MOVIMIENTO',   key: 'tipoMovimiento',   width: 18 },
    { header: 'PAQUETE ASIGNADO',  key: 'nombrePaquete',    width: 28 },
    { header: 'PAQUETE ANTERIOR',  key: 'nombrePaqueteAnterior', width: 28 },
    { header: 'MOTIVO',            key: 'motivo',           width: 35 },
    { header: 'SOLICITADO POR',    key: 'nombreSolicitante',width: 28 },
    { header: 'ESTATUS',           key: 'estatus',          width: 14 },
    { header: 'APROBADO/RECHAZADO POR', key: 'nombreAprobador', width: 28 },
    { header: 'COMENTARIO',        key: 'comentarioAprobacion', width: 40 },
    { header: 'FECHA APROBACIÓN',  key: 'fechaAprobacion',  width: 22 },
  ];

  sheet.columns.forEach((_col: any, idx: number) => {
    const letter = String.fromCharCode(65 + idx);
    sheet.getCell(`${letter}1`).fill = headerFill;
    sheet.getCell(`${letter}1`).font = headerFont;
    sheet.getCell(`${letter}1`).alignment = { horizontal: 'center' };
  });

  events.forEach((e) => {
    sheet.addRow({
      fechaSolicitud:        parseFecha(e.fechaSolicitud),
      tipoMovimiento:        TIPO_LABEL[e.tipoMovimiento] ?? e.tipoMovimiento,
      nombrePaquete:         e.nombrePaquete ?? '—',
      nombrePaqueteAnterior: e.nombrePaqueteAnterior ?? '—',
      motivo:                e.motivo ?? '—',
      nombreSolicitante:     e.nombreSolicitante ?? '—',
      estatus:               e.estatus,
      nombreAprobador:       e.nombreAprobador ?? '—',
      comentarioAprobacion:  e.comentarioAprobacion ?? '—',
      fechaAprobacion:       parseFecha(e.fechaAprobacion),
    });
  });

  const nombreArchivo = `Historial_Paquetes_${nombreColaborador.replace(/\s+/g, '_') || 'colaborador'}.xlsx`;

  workbook.xlsx.writeBuffer().then((data: Blob) => {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = nombreArchivo;
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};
